module.exports = __webpack_public_path__ + "img/Weapon_161.cf070496.png";